import { FormattedMessage } from 'react-intl';
import React from 'react';

export const notificationDuration = 3;

export {
  appConfig,
  contactUsUrl,
  googleAnalytisTrackingId,
  stripePublishKey,
  vendorSignup,
  vpmServerUrl,
} from './appConfig';

export const handleSearchTxt = vendorType => {
  if (vendorType === 'VENUE' || vendorType === 'venues') {
    return 'app.loader.txt';
  }
  if (vendorType === 'CATERER' || vendorType === 'caterers') {
    return 'app.catererCategory.fetchCatererTxt';
  }
  if (vendorType === 'PHOTOGRAPHER' || vendorType === 'photographers') {
    return 'app.photography.fetchPhotographerTxt';
  }
  return 'app.decoratorView.fetchDecorTxt';
};

export const handleRouteName = vendorType => {
  if (vendorType === 'VENUE' || vendorType === 'venues') {
    return 'app.search.venues';
  }
  if (vendorType === 'CATERER' || vendorType === 'caterers') {
    return 'app.search.caterers';
  }
  if (vendorType === 'PHOTOGRAPHER' || vendorType === 'photographers') {
    return 'app.search.photographers';
  }
  return 'app.search.decorators';
};

export const handleServices = service => {
  if (service === 'Venue' || service === 'venues') {
    return <FormattedMessage id="app.orderDetails.venue" />;
  }
  if (service === 'Catering' || service === 'caterers') {
    return <FormattedMessage id="app.orderDetails.catering" />;
  }
  if (service === 'Decor' || service === 'decorators') {
    return <FormattedMessage id="app.orderDetails.decor" />;
  }
  if (service === 'Photography' || service === 'photographers') {
    return <FormattedMessage id="app.orderDetails.photography" />;
  }
  return null;
};
